import React, { useState } from "react";
import { initialStateExport } from "../constant";
import { useSearchParams } from "react-router-dom";

const useExportRegister = () => {
    // * export register states
    const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
    const [checkboxes, setCheckboxes] = useState(initialStateExport);
    const [viewFormer, setViewFormer] = useState(0);
    const [path, setPath] = useState("");
    const [searchParams, _] = useSearchParams();

    //  * functions
    //  * functions
    //  * functions
    const onConfirmExportRegister = () => {
        const personal = checkboxes.personal;
        const contract = checkboxes.contract;
        const personal_query = Object.entries(personal)
            .filter((el) => el[1] === true)
            .map((el) => "&q=" + el[0])
            .join("");
        const contract_query = Object.entries(contract)
            .filter((el) => el[1] === true)
            .map((el) => "&q=" + el[0])
            .join("");

        const path = `${(personal_query + contract_query).replace("&", "?")}`;
        const currentParams = searchParams.toString().replaceAll("q=", "s=");

        const andOrSeparator =
            path === ""
                ? `?view_former=${viewFormer ? "1" : "0"}${
                      currentParams ? `&${currentParams}` : ""
                  }`
                : `&view_former=${viewFormer ? "1" : "0"}${
                      currentParams ? `&${currentParams}` : ""
                  }`;
        setPath(path + andOrSeparator);
        return;
    };

    return {
        path,
        openDownloadDialog,
        checkboxes,
        viewFormer,
        setPath,
        setOpenDownloadDialog,
        setCheckboxes,
        setViewFormer,
        onConfirmExportRegister,
    };
};

export default useExportRegister;
